<script>
    export let inline = false;
    export let callback = () => {};
    export let isChecked = false;
    export let isDisabled = false;
    export let label = '';
    export let parentGroup;
    export let rightAlignedText = null;
    export let subText = null;
    export let tooltip = null;
    export let value;
    export let isSmall = false;

    const cid = _.uniqueId();

    function handleChange(event) {
        if (callback) {
            callback(parseInt(event.target.value));
        }
    }
</script>

<label
    id={cid}
    class="radiobtn"
    class:radiobtn--inline={inline}
    class:is-small={isSmall}
    title={tooltip}
>
    <input
        type="radio"
        name={parentGroup}
        {value}
        on:change={handleChange}
        disabled={isDisabled}
        checked={isChecked}
    />
    <span class="radiobtn__dot"><div></div></span>
    <span class="label-container">
        <span class="label">
            <slot name="label">
                {label}
            </slot>
        </span>
        {#if subText}
            <span class="sub-text">{subText}</span>
        {/if}
    </span>
    <slot name="right">
        {#if rightAlignedText}
            <span class="right-aligned-text">{rightAlignedText}</span>
        {/if}
    </slot>
</label>

<style lang="scss">

    .radiobtn {
        --size: 24px;
        --dot-size: 10px;
        --spacing-right: 16px;

        position: relative;
        display: flex;
        align-items: center;

        cursor: pointer;

        &--inline {
            display: inline-flex;
            margin-right: $spacing-16;
            min-height: $spacing-32;
        }

        &__dot {
            display: flex;
            justify-content: center;
            align-items: center;

            width: var(--size);
            min-width: var(--size);
            height: var(--size);

            margin-right: var(--spacing-right);
            background: $white;

            border: 1px solid $status-gray;

            border-radius: 50%;

            > div {
                width: var(--dot-size);
                height: var(--dot-size);
                border-radius: inherit;
            }
        }

        input {
            position: absolute;
            opacity: 0;
            z-index: -1;
            cursor: pointer;

            &:disabled ~ * {
                opacity: 0.4;
                cursor: not-allowed;
            }

            &:checked {
                ~ .radiobtn__dot {
                    background-color: $blue;
                    border-color: $blue;

                    > div {
                        background-color: $white;
                    }
                }
            }

            &:focus {
                ~ .radiobtn__dot {
                    @include box-shadow-focus;
                }
            }
        }

        &.is-small {
            --size: 20px;
            --dot-size: 8px;
            --spacing-right: 8px;
        }
    }

    .label-container {
        flex-grow: 1;
    }

    .label {
        display: block;
    }

    .sub-text {
        display: block;
        margin-top: 2px;
        color: $status-gray;
    }

    .right-aligned-text {
        color: $status-gray;
        text-align: right;
        margin-left: $spacing-8;
    }
</style>
